import { jsxs as s, jsx as r } from "react/jsx-runtime";
import '../../assets/Card.css';function l({ children: a, style: d, className: c = "", title: e }) {
  return /* @__PURE__ */ s("div", { className: `card ${c}`, style: d, children: [
    /* @__PURE__ */ r("div", { className: "card-header", children: e }),
    /* @__PURE__ */ r("div", { className: "card-body", children: a })
  ] });
}
export {
  l as Card
};
//# sourceMappingURL=Card.js.map
